import { render, staticRenderFns } from "./ConsiderationsDocumentUpload.vue?vue&type=template&id=46f0d51e&"
import script from "./ConsiderationsDocumentUpload.vue?vue&type=script&lang=js&"
export * from "./ConsiderationsDocumentUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports